import React from 'react';
import Layout from '../components/Layout/Layout';

const GenericPdfPage = ({ title, fileUrl, isImage }) => {
  return (
    <Layout>
      <div className="page-container" style={{ maxWidth: '1000px', margin: '40px auto', padding: '0 20px' }}>
        <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '30px', textAlign: 'center' }}>
          {title}
        </h2>
        
        <div style={{ backgroundColor: '#fff', padding: '0', borderRadius: '4px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
          {fileUrl ? (
            isImage ? (
              <img src={fileUrl} alt={title} style={{ width: '100%', height: 'auto', display: 'block' }} />
            ) : (
              <iframe src={fileUrl} width="100%" height="800px" title={title} style={{ border: 'none' }} />
            )
          ) : (
            <div style={{ width: '100%', height: '800px', backgroundColor: '#333', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', textAlign: 'center', padding: '20px' }}>
              <p>[ Embedded Document Viewer for {title} ]<br/><br/><i>File not yet provided for this section.</i></p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default GenericPdfPage;
